import { Component, Input } from '@angular/core';
import {
  AbstractControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule, JsonPipe, SlicePipe } from '@angular/common';
import { BaseRules, TextValues } from './massachusetts-model';
import { UimuiBaseStateComponent } from '../uimui-base-state.component';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-massachusetts',
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    CommonModule,
    TruncateModule,
    TooltipModule,
  ],
  templateUrl: './massachusetts.component.html',
  styleUrl: './massachusetts.component.scss',
})
export class MassachusettsComponent extends UimuiBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('massachusetts', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('massachusetts', null);
    }
  }

  override setupHookForDropDownData() {
    if (
      this.baseRules?.selectionId ===
      'PolicyLiabilityLimits_CombinedSingleLimit'
    ) {
      this.baseRulesService.pdfDataDump['massachusetts'] = {
        ...this.baseRulesService.pdfDataDump['massachusetts'],
        umuimselect_levelone_radio: true,
      };
    }
  }
}
